import { canonicalPairFor } from "./assetClass";

export const MAX_WATCHLIST_SYMBOLS = 12;

export interface PortfolioWatchlist {
  id: string;
  name: string;
  symbols: string[];
  createdAt: string;
  lastAlert?: string;
  riskScore: number;
}

export interface SavePortfolioWatchlistResult {
  watchlist: PortfolioWatchlist;
  created: boolean;
}

/**
 * Convert a human-entered book into the exact symbol keys used by surveillance.
 * Quantities and values are deliberately not accepted by this path.
 */
export function normalizeWatchSymbols(
  raw: unknown,
  maxSymbols: number = MAX_WATCHLIST_SYMBOLS,
): string[] {
  const items = Array.isArray(raw)
    ? raw
    : typeof raw === "string"
      ? raw.split(/[,;\n]+|\s+/)
      : [];
  const limit = Math.max(1, Math.min(MAX_WATCHLIST_SYMBOLS, Math.floor(maxSymbols)));
  const symbols: string[] = [];
  const seen = new Set<string>();

  for (const item of items) {
    const typed =
      typeof item === "string"
        ? item
        : item && typeof item === "object"
          ? String((item as { symbol?: unknown }).symbol ?? "")
          : "";
    const symbol = canonicalPairFor(typed);
    if (!symbol || symbol.length > 20 || !/^[A-Z0-9][A-Z0-9.-]*$/.test(symbol)) continue;
    if (seen.has(symbol)) continue;
    seen.add(symbol);
    symbols.push(symbol);
    if (symbols.length >= limit) break;
  }

  return symbols;
}

export function hasActivePaidSubscription(
  stripeSubscriptionId: unknown,
  subscriptionStatus: unknown,
): boolean {
  if (typeof stripeSubscriptionId !== "string" || !stripeSubscriptionId.trim()) return false;
  const status = String(subscriptionStatus ?? "").toLowerCase();
  return status === "active" || status === "trialing";
}
